import { render, staticRenderFns } from "./NuevoFiltro.vue?vue&type=template&id=483c662e&"
import script from "./NuevoFiltro.vue?vue&type=script&lang=js&"
export * from "./NuevoFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports